import { atom } from "recoil";


const skillsAtom = atom({
  key: 'skills',
  default: {
    payload: [],
    loading: false,
    total: 0
  }
});

const crudSkillsAtom = atom({
  key: 'crudSkills',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});


export { crudSkillsAtom, skillsAtom};